import React, {PropTypes} from 'react';
import {Link} from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import InlineSVG from 'svg-inline-react';
import RotationMeter from '../../objects/kpi/RotationKpiMeter';
import Badge from '../../objects/badges/Badge';

import * as localStorage from '../../../localStorage/localStorage';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as kpiHelper from '../../../helpers/kpiHelper';
import * as kpiModels from '../../../models/kpiModels';
import * as kpiConstants from '../../../constants/kpiConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as componentConstants from '../../../constants/componentConstants';
import * as appConstants from '../../../constants/appConstants';
import * as keyboardConstants from '../../../constants/keyboardConstants';
class LearninPlanBitePanel extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            filter: this.props.filter,
            userBite: this.props.userBite,
            lang: this.props.lang,
            locale: appHelper.getLocalData(this.props.menuData),
            biteLocale: appHelper.getLocalData(this.props.bite),
            primaryKpi: appHelper.isDefined(this.props.bite.score_kpi) ? this.props.bite.score_kpi : {},
            performance_kpis: appHelper.isDefined(this.props.bite.performance_kpis) && this.props.bite.performance_kpis.length ? this.props.bite.performance_kpis : [],
            assets: {
                thumbnail: {
                    src: "",
                    type: "",
                    type_id: ""
                },
                icon: {
                    src: "",
                    type: "",
                    type_id: ""
                }
            },
            checkForUpdate: false,
            badges: this.props.bite.badges,
            badgeUserData: this.props.userBite.badges,
            showAchievedCount: true,
            showAchievedState: true,
            isEnabled: false,
            updateEnabledBite: false,
            optionLabel: appHelper.getLocaleString("optional_label")
        };
        this.getAssets = this.getAssets.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.setBite = this.setBite.bind(this);
        this.goToBite = this.goToBite.bind(this);
        this.getUserProgressClass = this.getUserProgressClass.bind(this);
        this.setEnabledState = this.setEnabledState.bind(this);
        this.isBiteEnabled = this.isBiteEnabled.bind(this);
        this.getBiteEnabledState = this.getBiteEnabledState.bind(this);
        this.getUserBadge = this.getUserBadge.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
    }

    componentDidMount() {
        this.getAssets();
        this.setEnabledState();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.filter !== nextProps.filter) {
            this.setState({filter: nextProps.filter});
        }
        if (this.state.userBite !== nextProps.userBite) {
            this.setState({
                userBite: Object.assign({}, nextProps.userBite),
                badgeUserData: Object.assign([], nextProps.userBite.badges),
                updateEnabledBite: true
            });
        }

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.props.menuData),
                biteLocale: appHelper.getLocalData(this.props.bite),
                optionLabel: appHelper.getLocaleString("optional_label")
            });
        }
    }

    componentDidUpdate() {
        if (this.state.checkForUpdate && this.props.trackingData.lesson_location === this.props.bite.screens[0].screen_id) {
            this.goToBite();
        }

        if(this.state.updateEnabledBite){
            this.setEnabledState();
        }
    }

    getAssets() {

        let iconAsset = appHelper.getIconAsset(this.props.menuData.icon);

        this.setState({
            assets: Object.assign({}, this.state.assets, {
                icon: iconAsset
            })
        });
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    setBite() {

        if (this.isBiteEnabled()) {
            let screen_id = this.props.bite.screens[0].screen_id;
            this.props.actions.setNewLessonLocation(screen_id);
            this.setState({checkForUpdate: true});
            //this.context.router.push(this.props.bite.bite_id);

        }
    }

    goToBite() {
        this.setState({checkForUpdate: false});
        this.context.router.push(this.props.bite.bite_id);
    }

    getUserProgressClass() {
        let className = ``;

        if (this.state.userBite.status === objectConstants.STATUS_NOT_REQUIRED) {
            className += `${objectConstants.CLASS_NOT_REQUIRED} `;
        } else if (this.state.userBite.status === objectConstants.STATUS_IN_PROGRESS) {
            className += `${objectConstants.CLASS_IN_PROGRESS} `;
        } else if (this.state.userBite.status === objectConstants.STATUS_COMPLETE) {
            className += `${objectConstants.CLASS_COMPLETE} `;
        } else {
            className += `${objectConstants.CLASS_NOT_STARTED} `;
        }

        return className;
    }

    setEnabledState() {
        this.setState({
            updateEnabledBite: false
        });
        let isEnabled = false;
        switch (this.props.contentData.experience.experience_learning_model) {
            case componentConstants.MENU_TYPE_LINEAR_LEARNING_PLAN:
                isEnabled = appHelper.checkLinearMenuBiteEnabled(this.state.userBite,this.props.userData);
                break;
            case componentConstants.MENU_TYPE_OPEN_LEARNING_PLAN:
                isEnabled = appHelper.checkOpenMenuBiteEnabled(this.state.userBite,this.props.userData);
                break;
            case componentConstants.MENU_TYPE_FIRST_ANY_LAST_LEARNING_PLAN:
                isEnabled = appHelper.checkFirstLastAnyMenuBiteEnabled(this.state.userBite,this.props.userData);
                break;
            case componentConstants.MENU_TYPE_PERSONAL_LEARNING_PLAN:
                isEnabled = appHelper.checkOpenMenuBiteEnabled(this.state.userBite,this.props.userData);
                break;
            default:
                isEnabled = appHelper.checkLinearMenuBiteEnabled(this.state.userBite,this.props.userData);
        }

        this.setState({isEnabled: isEnabled});
    }

    isBiteEnabled() {
        return this.state.isEnabled;
    }

    getBiteEnabledState() {
        return this.isBiteEnabled() ? "" : "disabled";
    }

    getUserBadge(badge) {
        return appHelper.getArrayObjectByKey(this.state.badgeUserData, "badge_id", badge.badge_id);
    }

    setKeyboardAccessibility(event) {

        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            event.stopPropagation();
            this.setBite();
        }
    }

    // <InlineSVG className="guroo-icon" src={this.getImagePath(this.state.assets.icon.src)}/>
    render() {
        return (
            <div>
                {
                    (this.state.filter === "required" && this.props.required) || this.state.filter !== "required"
                        ?
                        <div className={`menu-panel ${this.getBiteEnabledState()}`} onClick={this.setBite} onKeyDown={this.setKeyboardAccessibility} tabIndex={0} role="link">

                            <div className={`icon-container ${this.getUserProgressClass()}`}>
                                {
                                    appHelper.isDefined(this.state.assets.icon) && this.state.assets.icon.src.length > 0
                                        ?
                                        <div className="thumbnail-icon">
                                            <img className="guroo-icon" src={this.getImagePath(this.state.assets.icon.src)} alt=""/>
                                        </div>
                                        : null
                                }

                            </div>

                            <div className="content-container">

                                {
                                     appHelper.isDefined(this.state.primaryKpi.kpi_id) && this.state.primaryKpi.kpi_id !== null && this.state.primaryKpi.is_visible && ((appHelper.isDefined(this.props.menuData.display_score) && this.props.menuData.display_score) || !appHelper.isDefined(this.props.menuData.display_score))
                                        ?
                                        <div className="kpi-meter-container">
                                            <div className="kpi-meter">
                                                <RotationMeter bite_id={this.props.bite.bite_id}
                                                               kpiDefaults={this.state.primaryKpi}
                                                               meterParams={kpiModels.DEFAULT_KPI_ROTATION_METER_PARAMS}
                                                               displayState={kpiConstants.KPI_DISPLAY_STATE_CURRENT_VALUE_NO_LABEL}/>
                                            </div>
                                        </div>
                                        :
                                        null
                                }



                                {
                                    this.state.badges.length > 0 && ((appHelper.isDefined(this.props.menuData.display_badges) && this.props.menuData.display_badges) || !appHelper.isDefined(this.props.menuData.display_badges))
                                        ?
                                        <div className="thumbnail-badge-container">
                                            <ul className="badge-grid">
                                                {this.state.badges.map(badge =>
                                                    !appHelper.isDefined(badge.is_visible) || (appHelper.isDefined(badge.is_visible) && badge.is_visible)
                                                        ?
                                                        <li key={badge.badge_id} className="badge-grid-item">
                                                            <Badge badge={badge}
                                                                   userBadge={this.getUserBadge(badge)}
                                                                   showAchievedCount={this.state.showAchievedCount}
                                                                   showAchievedState={this.state.showAchievedState}
                                                            />
                                                        </li>
                                                        :
                                                        null
                                                )}
                                            </ul>
                                        </div>
                                        :
                                        null
                                }
                                <div className={`bite-title`}>
                                    {
                                        appHelper.isDefined(this.state.locale.sur_title) && this.state.locale.sur_title !== null  && this.state.locale.sur_title.length > 0
                                            ?
                                            <div className="sur-title">{this.state.locale.sur_title}</div>
                                            :
                                            null
                                    }
                                    <span
                                        className={`title ${this.getUserProgressClass()}`}> {this.state.biteLocale.title}</span>

                                    {!this.props.required
                                        ?
                                        <span className="required">{this.state.optionLabel}</span>
                                        :
                                        null
                                    }


                                </div>
                                {appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0
                                    ?
                                    <div className="description"
                                         dangerouslySetInnerHTML={{__html: this.state.locale.description}}/>
                                    : null
                                }


                            </div>
                        </div>
                        : null
                }

            </div>
        );
    }
}


/*
* {this.state.performance_kpis.length > 0
                                    ?
                                    this.state.performance_kpis.map(kpi =>
                                    <div className="kpi-meter-container" key={kpi.kpi_id}>
                                        <div className="kpi-meter">
                                            <RotationMeter bite_id={this.props.bite.bite_id}
                                                           kpiDefaults={kpi}
                                                           meterParams={kpiModels.DEFAULT_KPI_ROTATION_METER_PARAMS}
                                                           displayState={kpiConstants.KPI_DISPLAY_STATE_CURRENT_VALUE_NO_LABEL}/>
                                        </div>
                                    </div>
                                     )
                                    :null
                                }

* */
LearninPlanBitePanel.propTypes = {
    menuData: PropTypes.object.isRequired,
    bite: PropTypes.object.isRequired,
    required: PropTypes.bool.isRequired,
    filter: PropTypes.string.isRequired,
    userBite: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    contentData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

LearninPlanBitePanel.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        userBite: userDataHelper.getBiteUserData(state.userData, ownProps.bite.bite_id),
        userData: state.userData,
        trackingData: state.trackingData,
        contentData: state.contentData

    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LearninPlanBitePanel);



/** WEBPACK FOOTER **
 ** ./src/components/menus/learningPlan/LearninPlanBitePanel.js
 **/